import React from 'react';

const WhyUs = () => {
  const scrollToOrder = () => {
    document.getElementById("order").scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="bg-white py-12 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-lg md:text-3xl lg:text-4xl font-extrabold text-green-700 mb-8 lg:mb-10 leading-snug">
          🌿 সম্পূর্ণ প্রাকৃতিক উপাদানে তৈরি
        </h2>
        
        <img 
          src="/images/ingredients.jpg" 
          alt="প্রাকৃতিক উপাদান" 
          className="max-w-4xl w-full mx-auto rounded-2xl shadow-md mb-8 lg:mb-10 object-cover"
        />
        
        <div className="flex flex-col sm:flex-row justify-center items-center gap-3 md:gap-6 mb-10 w-fit mx-auto">
          <div className="flex items-center gap-2 bg-green-50 px-5 py-2.5 rounded-full border border-green-200 shadow-sm w-full sm:w-auto">
            <span className="text-xl">✅</span>
            <span className="text-gray-800 font-bold text-[15px] md:text-base whitespace-nowrap">১০০% হোমমেড</span>
          </div>
          <div className="flex items-center gap-2 bg-green-50 px-5 py-2.5 rounded-full border border-green-200 shadow-sm w-full sm:w-auto">
            <span className="text-xl">✅</span>
            <span className="text-gray-800 font-bold text-[15px] md:text-base whitespace-nowrap">কোনো প্রিজার্ভেটিভ নেই</span>
          </div>
          <div className="flex items-center gap-2 bg-green-50 px-5 py-2.5 rounded-full border border-green-200 shadow-sm w-full sm:w-auto">
            <span className="text-xl">✅</span>
            <span className="text-gray-800 font-bold text-[15px] md:text-base whitespace-nowrap">শিশুর জন্য সম্পূর্ণ নিরাপদ</span>
          </div>
        </div>

        <button
          onClick={scrollToOrder}
          className="relative group w-[90%] sm:w-full max-w-sm sm:max-w-md mx-auto block text-center mt-8 sm:mt-12 mb-4 rounded-xl transition-transform duration-300 hover:-translate-y-1"
        >
          {/* Base metallic gradient & shadow layer */}
          <div className="absolute inset-0 bg-gradient-to-b from-green-500 via-green-600 to-green-700 rounded-xl shadow-[0_8px_20px_rgba(22,163,74,0.5)] sm:shadow-[0_10px_30px_rgba(22,163,74,0.6)] group-hover:shadow-[0_12px_25px_rgba(22,163,74,0.7)] sm:group-hover:shadow-[0_15px_40px_rgba(22,163,74,0.8)] transition-shadow duration-300"></div>
          
          {/* Metallic Top Glare */}
          <div className="absolute top-0 inset-x-0 h-1/2 bg-gradient-to-b from-white/40 to-transparent rounded-t-xl pointer-events-none"></div>
          
          {/* Bottom Reflection */}
          <div className="absolute bottom-0 inset-x-0 h-1/4 bg-gradient-to-t from-black/20 to-transparent rounded-b-xl pointer-events-none"></div>

          {/* Animated Shine Effect */}
          <div className="absolute inset-0 overflow-hidden rounded-xl">
             <div className="absolute inset-0 -translate-x-[150%] group-hover:translate-x-[150%] transition-transform duration-1000 ease-in-out bg-gradient-to-r from-transparent via-white/50 to-transparent w-full skew-x-[-20deg]"></div>
          </div>

          {/* Button Content */}
          <div className="relative flex items-center justify-center gap-2 sm:gap-3 py-2.5 sm:py-4 px-3 sm:px-6 border border-white/40 rounded-xl">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-5 h-5 sm:w-8 sm:h-8 text-white drop-shadow-md">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59" />
            </svg>
            <span className="text-white font-black text-[16px] min-[375px]:text-[17px] sm:text-2xl tracking-wide drop-shadow-[0_2px_2px_rgba(0,0,0,0.6)]">
              অর্ডার করতে এখানে ক্লিক করুন
            </span>
          </div>
        </button>
      </div>
    </section>
  );
};

export default WhyUs;
